import { useContext, useState } from "react";
import { CommentButton } from "./CommentButton";
import { CommentSection } from "./CommentSection";
import { PauseButton } from "./PauseButton";
import replayIcon from '../../images/replay.svg';
import styles from "./week-reflection.module.css";
import { ShareLinkContext } from "../share/ShareLinkContext";
import ShareButton from "../share/ShareButton";
import { WeekReflectionContext } from "./WeekReflectionContext";

export const StoryWrapper = ({ children, action, isPaused, storyName, areCommentsEnabled = true,
    showPauseButton = true }) => {

    const [areCommentsOpen, setAreCommentsOpen] = useState(false);
    const { reflectionId, lastStoryName, handleRestart } = useContext(WeekReflectionContext);
    const { isSelectionModeOn } = useContext(ShareLinkContext);
    const [isStoryLast] = useState(lastStoryName === storyName);

    const openComments = async () => {
        await new Promise((resolve) => setTimeout(() => {
            action('pause');
            resolve();
        }, 100));

        setAreCommentsOpen(true)
    }

    const closeComments = async () => {
        await new Promise((resolve) => setTimeout(() => {
            action('play');
            resolve();
        }, 100));

        setAreCommentsOpen(false)
    }

    return (
        <div className={styles.contentContainer}>
            {!isSelectionModeOn && showPauseButton && !isStoryLast && <PauseButton action={action} isPaused={isPaused} />}
            {!isSelectionModeOn && isStoryLast &&
                <button className={styles.replayButton} onClick={handleRestart}>
                    <img className={styles.icon} src={replayIcon} alt="replay icon" height={28} />
                </button>
            }
            {storyName === 'intro' && !isSelectionModeOn &&
                <div style={!reflectionId ? { opacity: 0 } : { opacity: 1, transition: 'opacity 0.6s ease-in' }}>
                    <ShareButton entryId={reflectionId} shareType={'story'} buttonType={'storyShareIcon'} />
                </div>
            }
            {children}
            {areCommentsEnabled &&
                <>
                    <CommentButton openComments={openComments} storyName={storyName} />
                    <CommentSection isOpen={areCommentsOpen} closeComments={closeComments} storyName={storyName} />
                </>
            }
        </div>
    )
}